function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as Api from "../ajax/SessionApi";
import IntlMessage from '../commons/Intl';
import { Placeholder, Action, Members, Label } from '../commons/IntlMessages';
import { NotifyStatuses } from "../enum/NotifyStatuses";
import * as UserGroupNarrowdownModalComponent from "./UserGroupNarrowdownModalComponent";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // メンバーモーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 更新
   */

  Mode[Mode["Modify"] = 2] = "Modify";
  /**
   * 表示のみ
   */

  Mode[Mode["ReadOnly"] = 3] = "ReadOnly";
})(Mode || (Mode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    _this.state = {
      Modal: null,
      OwnerName: _this.props.ownerName,
      OriginalTargetUserList: [],
      NonTargetUserList: [],
      TargetUserList: [],
      SelectedTargetUserList: [],
      SelectedNonTargetUserList: [],
      NonTargetSearchText: "",
      TargetSearchText: "",
      ErrorMessages: [],
      NonTargetUserGroupNarrowdownModalMode: UserGroupNarrowdownModalComponent.Mode.None,
      NonTargetUserGroupNarrowdownGroupNamesText: "",
      NonTargetUserGroupNarrowdownSelectedGroupIdList: [],
      NonTargetUserGroupNarrowdownUserKeyList: [],
      NonTargetUserGroupNarrowdownModalLeft: 0,
      NonTargetUserGroupNarrowdownModalTop: 0,
      TargetUserGroupNarrowdownModalMode: UserGroupNarrowdownModalComponent.Mode.None,
      TargetUserGroupNarrowdownGroupNamesText: "",
      TargetUserGroupNarrowdownSelectedGroupIdList: [],
      TargetUserGroupNarrowdownUserKeyList: [],
      TargetUserGroupNarrowdownModalLeft: 0,
      TargetUserGroupNarrowdownModalTop: 0
    };

    _this.GetMember();

    _this.changePositionOpenNonTargetUserGroupNarrowdownButtonFunction = _this.changePositionOpenNonTargetUserGroupNarrowdownButton.bind(_assertThisInitialized(_this));
    _this.changePositionOpenTargetUserGroupNarrowdownButtonFunction = _this.changePositionOpenTargetUserGroupNarrowdownButton.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * 未対象ユーザーグループ絞り込みモーダル開くボタンの位置変更
   */


  _createClass(MainComponent, [{
    key: "changePositionOpenNonTargetUserGroupNarrowdownButton",
    value: function changePositionOpenNonTargetUserGroupNarrowdownButton() {
      var btn = $('#OpenNonTargetUserGroupNarrowdown-button');
      var btn_off = btn.offset();

      if (btn && btn_off) {
        var outerHeight = btn.outerHeight(false);

        if (outerHeight) {
          this.setState({
            NonTargetUserGroupNarrowdownModalTop: btn_off.top + outerHeight,
            NonTargetUserGroupNarrowdownModalLeft: btn_off.left
          });
        }
      }
    }
    /**
     * 対象ユーザーグループ絞り込みモーダル開くボタンの位置変更
     */

  }, {
    key: "changePositionOpenTargetUserGroupNarrowdownButton",
    value: function changePositionOpenTargetUserGroupNarrowdownButton() {
      var btn = $('#OpenTargetUserGroupNarrowdown-button');
      var btn_off = btn.offset();

      if (btn && btn_off) {
        var outerHeight = btn.outerHeight(false);

        if (outerHeight) {
          this.setState({
            TargetUserGroupNarrowdownModalTop: btn_off.top + outerHeight,
            TargetUserGroupNarrowdownModalLeft: btn_off.left
          });
        }
      }
    }
    /**
     * 選択ユーザーリスト取得
     */

  }, {
    key: "GetMember",
    value: function GetMember() {
      var _this2 = this;

      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      Api.GetMember(this.props.sessionId, function (data) {
        setTimeout(function () {
          $("#overlay").fadeOut(300);
        }, 500);
        var ownerName = _this2.props.ownerName;
        var ownerUsers = data.ChooseableUserList.filter(function (x) {
          return x.Key == _this2.props.ownerKey;
        });

        if (ownerUsers.length > 0) {
          var ownerUser = ownerUsers[0];

          if (ownerUser.IsSupporter) {
            ownerName += " (" + intl.format(Label.Support) + ")";
          }
        }

        var targetUserList = data.TargetUserList.filter(function (x) {
          return x.Key != _this2.props.ownerKey;
        });
        var chooseableUserList = data.ChooseableUserList.filter(function (x) {
          return x.Key != _this2.props.ownerKey;
        });

        _this2.setState({
          OwnerName: ownerName,
          OriginalTargetUserList: targetUserList,
          NonTargetUserList: $.extend(true, [], chooseableUserList.filter(function (x) {
            return targetUserList.filter(function (y) {
              return y.Key == x.Key;
            }).length == 0;
          })),
          TargetUserList: $.extend(true, [], chooseableUserList.filter(function (x) {
            return targetUserList.filter(function (y) {
              return y.Key == x.Key;
            }).length > 0;
          })),
          ErrorMessages: []
        });
      });
    }
    /**
     * 「登録」ボタン押下時の処理を行います。
     */

  }, {
    key: "onModify",
    value: function onModify() {
      if (this.state.Modal == null) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        var userKeys = [];
        this.state.TargetUserList.map(function (x) {
          userKeys.push(x.Key);
        });
        this.props.onModify(this.props.sessionId, userKeys, this.props.updateDateTime);
        this.state.Modal.modal('hide');
      }
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      var modal = $('#SessionMemberModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function () {
        _this3.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
      window.addEventListener('resize', this.changePositionOpenNonTargetUserGroupNarrowdownButtonFunction);
      window.addEventListener('resize', this.changePositionOpenTargetUserGroupNarrowdownButtonFunction);
      $("#SessionMemberModal").on("scroll", this.changePositionOpenNonTargetUserGroupNarrowdownButtonFunction);
      $("#SessionMemberModal").on("scroll", this.changePositionOpenTargetUserGroupNarrowdownButtonFunction);
    }
    /**
     * コンポーネントが破棄(アンマウント)される前に実行されます。
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.changePositionOpenNonTargetUserGroupNarrowdownButtonFunction);
      window.removeEventListener('resize', this.changePositionOpenTargetUserGroupNarrowdownButtonFunction);
      $("#SessionMemberModal").off("scroll", this.changePositionOpenNonTargetUserGroupNarrowdownButtonFunction);
      $("#SessionMemberModal").off("scroll", this.changePositionOpenTargetUserGroupNarrowdownButtonFunction);
    }
    /**
     * 未選択の検索テキストを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateNonTargetSearchText",
    value: function updateNonTargetSearchText(e) {
      this.setState({
        NonTargetSearchText: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * 対象の検索テキストを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateTargetSearchText",
    value: function updateTargetSearchText(e) {
      this.setState({
        TargetSearchText: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * 未対象ユーザーの選択状態を切り替えます。
     *
     * @param m モデル
     */

  }, {
    key: "changeSelectedNonTargetUser",
    value: function changeSelectedNonTargetUser(m) {
      var next = this.state.SelectedNonTargetUserList.filter(function (x, _i) {
        return x != m.Key;
      }); //前回と同じ場合は、未選択

      if (next.length == this.state.SelectedNonTargetUserList.length) {
        next.push(m.Key);
      }

      this.setState({
        SelectedNonTargetUserList: next
      });
    }
    /**
     * 対象ユーザーの選択状態を切り替えます。
     *
     * @param m モデル
     */

  }, {
    key: "changeSelectedTargetUser",
    value: function changeSelectedTargetUser(m) {
      var next = this.state.SelectedTargetUserList.filter(function (x, _i) {
        return x != m.Key;
      }); //前回と同じ場合は、未選択

      if (next.length == this.state.SelectedTargetUserList.length) {
        next.push(m.Key);
      }

      this.setState({
        SelectedTargetUserList: next
      });
    }
    /**
     * 全てのユーザーを会議から削除します。
     */

  }, {
    key: "removeAllUser",
    value: function removeAllUser() {
      var _this4 = this;

      this.state.TargetUserList.map(function (x) {
        _this4.state.NonTargetUserList.push(x);
      });
      this.setState({
        NonTargetUserList: this.state.NonTargetUserList,
        TargetUserList: [],
        SelectedTargetUserList: []
      });
    }
    /**
     * 対象のユーザーを会議から削除します。
     */

  }, {
    key: "removeUser",
    value: function removeUser() {
      var _this5 = this;

      var move_users = this.state.TargetUserList.filter(function (x, _i) {
        return _this5.state.SelectedTargetUserList.filter(function (y) {
          return x.Key == y;
        }).length > 0;
      });
      move_users.map(function (x) {
        _this5.state.NonTargetUserList.push(x);
      });
      this.setState({
        NonTargetUserList: this.state.NonTargetUserList,
        TargetUserList: this.state.TargetUserList.filter(function (x, _i) {
          return _this5.state.SelectedTargetUserList.filter(function (y) {
            return x.Key == y;
          }).length == 0;
        }),
        SelectedTargetUserList: []
      });
    }
    /**
     * 対象のユーザーを会議に追加します。
     */

  }, {
    key: "addUser",
    value: function addUser() {
      var _this6 = this;

      var move_users = this.state.NonTargetUserList.filter(function (x, _i) {
        return _this6.state.SelectedNonTargetUserList.filter(function (y) {
          return x.Key == y;
        }).length > 0;
      });
      move_users.map(function (x) {
        _this6.state.TargetUserList.push(x);
      });
      this.setState({
        NonTargetUserList: this.state.NonTargetUserList.filter(function (x, _i) {
          return _this6.state.SelectedNonTargetUserList.filter(function (y) {
            return x.Key == y;
          }).length == 0;
        }),
        TargetUserList: this.state.TargetUserList,
        SelectedNonTargetUserList: []
      });
    }
    /**
     * 全てのユーザーを会議に追加します。
     */

  }, {
    key: "addAllUser",
    value: function addAllUser() {
      var _this7 = this;

      this.state.NonTargetUserList.map(function (x) {
        _this7.state.TargetUserList.push(x);
      });
      this.setState({
        NonTargetUserList: [],
        TargetUserList: this.state.TargetUserList,
        SelectedNonTargetUserList: []
      });
    }
    /**
     * ユーザー通知状態取得
     *
     * @param id 対象ID
     */

  }, {
    key: "getUserNotifyStatus",
    value: function getUserNotifyStatus(key) {
      var targets = this.state.OriginalTargetUserList.filter(function (x) {
        return x.Key == key;
      });

      if (targets && targets.length > 0 && targets[0].NotifyStatus != NotifyStatuses.NotNotified) {
        return intl.format(Label.Invited);
      }

      return "";
    }
    /**
     * 未対象のユーザーグループ絞り込みを開きます。
     */

  }, {
    key: "onOpenNonTargetUserGroupNarrowdown",
    value: function onOpenNonTargetUserGroupNarrowdown(e) {
      if (this.state.NonTargetUserGroupNarrowdownModalMode != UserGroupNarrowdownModalComponent.Mode.None) {
        return;
      }

      e.stopPropagation();
      this.changePositionOpenNonTargetUserGroupNarrowdownButton();
      this.setState({
        NonTargetUserGroupNarrowdownModalMode: UserGroupNarrowdownModalComponent.Mode.Open,
        TargetUserGroupNarrowdownModalMode: UserGroupNarrowdownModalComponent.Mode.None
      });
    }
    /**
     * 未対象のグループの変更
     */

  }, {
    key: "onChangeNonTargetUserGroupNarrowdown",
    value: function onChangeNonTargetUserGroupNarrowdown(groupNamesText, selectedGroupIdList, _userIds, userKeys) {
      this.setState({
        NonTargetUserGroupNarrowdownGroupNamesText: groupNamesText,
        NonTargetUserGroupNarrowdownSelectedGroupIdList: selectedGroupIdList,
        NonTargetUserGroupNarrowdownUserKeyList: userKeys
      });
    }
    /**
     * 対象のユーザーグループ絞り込みを開きます。
     */

  }, {
    key: "onOpenTargetUserGroupNarrowdown",
    value: function onOpenTargetUserGroupNarrowdown(e) {
      if (this.state.TargetUserGroupNarrowdownModalMode != UserGroupNarrowdownModalComponent.Mode.None) {
        return;
      }

      e.stopPropagation();
      this.changePositionOpenTargetUserGroupNarrowdownButton();
      this.setState({
        NonTargetUserGroupNarrowdownModalMode: UserGroupNarrowdownModalComponent.Mode.None,
        TargetUserGroupNarrowdownModalMode: UserGroupNarrowdownModalComponent.Mode.Open
      });
    }
    /**
     * 対象のグループの変更
     */

  }, {
    key: "onChangeTargetUserGroupNarrowdown",
    value: function onChangeTargetUserGroupNarrowdown(groupNamesText, selectedGroupIdList, _userIds, userKeys) {
      this.setState({
        TargetUserGroupNarrowdownGroupNamesText: groupNamesText,
        TargetUserGroupNarrowdownSelectedGroupIdList: selectedGroupIdList,
        TargetUserGroupNarrowdownUserKeyList: userKeys
      });
    }
    /**
     * 外枠マウスダウン
     */

  }, {
    key: "onOutSide",
    value: function onOutSide(e) {
      e.preventDefault();
      this.setState({
        NonTargetUserGroupNarrowdownModalMode: UserGroupNarrowdownModalComponent.Mode.None,
        TargetUserGroupNarrowdownModalMode: UserGroupNarrowdownModalComponent.Mode.None
      });
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "SessionMemberModal",
        role: "dialog",
        onClick: this.onOutSide.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog " + (this.props.mode == Mode.Modify ? "modal-lg" : ""),
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "38",
        src: "/assets/img/member.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(Members.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-10 mx-auto"
      }, this.props.mode == Mode.Modify && /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 sessionName"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-12 ownerName"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-12 form-inline select-wrap-top"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-group col-7"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-group-prepend"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-group-text"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "14",
        height: "14",
        src: "/assets/img/search_icon.svg"
      }))), /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        maxLength: 50,
        onChange: function onChange(e) {
          return _this8.updateNonTargetSearchText(e);
        },
        value: this.state.NonTargetSearchText,
        tabIndex: 101,
        placeholder: intl.format(Placeholder.SearchWord)
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-group col-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "selectbox"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        id: "OpenNonTargetUserGroupNarrowdown-button",
        onClick: this.onOpenNonTargetUserGroupNarrowdown.bind(this),
        tabIndex: -1
      }, this.state.NonTargetUserGroupNarrowdownGroupNamesText)), this.state.NonTargetUserGroupNarrowdownModalMode != UserGroupNarrowdownModalComponent.Mode.None && /*#__PURE__*/React.createElement(UserGroupNarrowdownModalComponent["default"], {
        mode: this.state.NonTargetUserGroupNarrowdownModalMode,
        selectedGroupIdList: this.state.NonTargetUserGroupNarrowdownSelectedGroupIdList,
        onChange: this.onChangeNonTargetUserGroupNarrowdown.bind(this),
        top: this.state.NonTargetUserGroupNarrowdownModalTop,
        left: this.state.NonTargetUserGroupNarrowdownModalLeft
      }))), /*#__PURE__*/React.createElement("div", {
        className: "select-wrap-bottom"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "col-12 list-group list-group-flush"
      }, this.state.NonTargetUserList.filter(function (x) {
        return x.Name.indexOf(_this8.state.NonTargetSearchText) >= 0;
      }).filter(function (x) {
        return _this8.state.NonTargetUserGroupNarrowdownSelectedGroupIdList.length == 0 ? true : _this8.state.NonTargetUserGroupNarrowdownUserKeyList.some(function (z) {
          return z == x.Key;
        });
      }).map(function (x, _i) {
        return /*#__PURE__*/React.createElement("li", {
          onClick: _this8.changeSelectedNonTargetUser.bind(_this8, x),
          className: "list-group-item " + (_this8.state.SelectedNonTargetUserList.filter(function (y) {
            return y == x.Key;
          }).length > 0 ? "selected" : "")
        }, x.Name, x.IsSupporter ? " (" + intl.format(Label.Support) + ")" : "");
      })))), /*#__PURE__*/React.createElement("div", {
        className: "col-2 btn-area"
      }, /*#__PURE__*/React.createElement("div", {
        className: "btn-group-vertical"
      }, this.state.TargetUserList.length > 0 && /*#__PURE__*/React.createElement("a", {
        className: "btn btn-primary",
        onClick: this.removeAllUser.bind(this),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "20",
        height: "20",
        src: "/assets/img/move_left_all.svg"
      })), this.state.TargetUserList.length == 0 && /*#__PURE__*/React.createElement("div", {
        className: "btn btn-primary disabled"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "20",
        height: "20",
        src: "/assets/img/move_left_all.svg"
      })), this.state.SelectedTargetUserList.length > 0 && /*#__PURE__*/React.createElement("a", {
        className: "btn btn-primary",
        onClick: this.removeUser.bind(this),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "20",
        height: "20",
        src: "/assets/img/move_left.svg"
      })), this.state.SelectedTargetUserList.length == 0 && /*#__PURE__*/React.createElement("div", {
        className: "btn btn-primary disabled"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "20",
        height: "20",
        src: "/assets/img/move_left.svg"
      })), this.state.SelectedNonTargetUserList.length > 0 && /*#__PURE__*/React.createElement("a", {
        className: "btn btn-primary",
        onClick: this.addUser.bind(this),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "20",
        height: "20",
        src: "/assets/img/move_rigth.svg"
      })), this.state.SelectedNonTargetUserList.length == 0 && /*#__PURE__*/React.createElement("div", {
        className: "btn btn-primary disabled"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "20",
        height: "20",
        src: "/assets/img/move_rigth.svg"
      })), this.state.NonTargetUserList.length > 0 && /*#__PURE__*/React.createElement("a", {
        className: "btn btn-primary",
        onClick: this.addAllUser.bind(this),
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "20",
        height: "20",
        src: "/assets/img/move_rigth_all.svg"
      })), this.state.NonTargetUserList.length == 0 && /*#__PURE__*/React.createElement("div", {
        className: "btn btn-primary disabled"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "20",
        height: "20",
        src: "/assets/img/move_rigth_all.svg"
      })))), /*#__PURE__*/React.createElement("div", {
        className: "col-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto sessionName"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "ellipsis"
      }, this.props.sessionName)), /*#__PURE__*/React.createElement("div", {
        className: "col-12 mx-auto ownerName"
      }, /*#__PURE__*/React.createElement("p", {
        className: "ownerId ellipsis"
      }, this.state.OwnerName != null ? this.state.OwnerName : "")), /*#__PURE__*/React.createElement("div", {
        className: "col-12 form-inline select-wrap-top"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-group col-7"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-group-prepend"
      }, /*#__PURE__*/React.createElement("div", {
        className: "input-group-text"
      }, /*#__PURE__*/React.createElement("img", {
        className: "pageIcon",
        width: "14",
        height: "14",
        src: "/assets/img/search_icon.svg"
      }))), /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "form-control",
        maxLength: 50,
        onChange: function onChange(e) {
          return _this8.updateTargetSearchText(e);
        },
        value: this.state.TargetSearchText,
        tabIndex: 101,
        placeholder: intl.format(Placeholder.SearchWord)
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-group col-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "selectbox"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        id: "OpenTargetUserGroupNarrowdown-button",
        onClick: this.onOpenTargetUserGroupNarrowdown.bind(this),
        tabIndex: -1
      }, this.state.TargetUserGroupNarrowdownGroupNamesText)), this.state.TargetUserGroupNarrowdownModalMode != UserGroupNarrowdownModalComponent.Mode.None && /*#__PURE__*/React.createElement(UserGroupNarrowdownModalComponent["default"], {
        mode: this.state.TargetUserGroupNarrowdownModalMode,
        selectedGroupIdList: this.state.TargetUserGroupNarrowdownSelectedGroupIdList,
        onChange: this.onChangeTargetUserGroupNarrowdown.bind(this),
        top: this.state.TargetUserGroupNarrowdownModalTop,
        left: this.state.TargetUserGroupNarrowdownModalLeft
      }))), /*#__PURE__*/React.createElement("div", {
        className: "select-wrap-bottom"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "col-12 list-group list-group-flush"
      }, this.state.TargetUserList.filter(function (x) {
        return x.Name.indexOf(_this8.state.TargetSearchText) >= 0;
      }).filter(function (x) {
        return _this8.state.TargetUserGroupNarrowdownSelectedGroupIdList.length == 0 ? true : _this8.state.TargetUserGroupNarrowdownUserKeyList.some(function (z) {
          return z == x.Key;
        });
      }).map(function (x, _i) {
        return /*#__PURE__*/React.createElement("li", {
          key: x.Key,
          onClick: _this8.changeSelectedTargetUser.bind(_this8, x),
          className: "list-group-item list-group-item-flex " + (_this8.state.SelectedTargetUserList.filter(function (y) {
            return y == x.Key;
          }).length > 0 ? "selected" : "")
        }, /*#__PURE__*/React.createElement("div", {
          className: "list-group-item-left"
        }, x.Name, x.IsSupporter ? " (" + intl.format(Label.Support) + ")" : ""), /*#__PURE__*/React.createElement("div", {
          className: "list-group-item-right"
        }, _this8.getUserNotifyStatus(x.Key)));
      }))))), this.props.mode == Mode.ReadOnly && /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 sessionName"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "ellipsis"
      }, this.props.sessionName)), /*#__PURE__*/React.createElement("div", {
        className: "col-12 ownerName"
      }, /*#__PURE__*/React.createElement("p", {
        className: "ownerId ellipsis"
      }, this.state.OwnerName != null ? this.state.OwnerName : "")), /*#__PURE__*/React.createElement("div", {
        className: "col-12 select-wrap"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "col-12 list-group list-group-flush"
      }, this.state.TargetUserList.map(function (x, _i) {
        return /*#__PURE__*/React.createElement("li", {
          className: "list-group-item"
        }, x.Name, x.IsSupporter ? " (" + intl.format(Label.Support) + ")" : "");
      })))))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, this.props.mode == Mode.Modify && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onModify.bind(this),
        tabIndex: -1
      }, intl.format(Action.Update))))));
    }
  }]);

  return MainComponent;
}(React.Component);

export { MainComponent as default };